import { useQuery, useMutation, invalidateKeys } from '../lib/query';
import { listLocations, bulkLocations } from '../services/location';

const KEY = 'location';

export const useLocations = (params) =>
  useQuery({ queryKey: [KEY, params], queryFn: () => listLocations(params) });

export const useBulkLocations = (opts = {}) =>
  useMutation({
    mutationFn: (items) => bulkLocations(items),
    onSuccess: (data, vars) => { invalidateKeys([KEY]); opts.onSuccess?.(data, vars); },
    onError: opts.onError,
  });
